import React from 'react';
import { GripVertical } from 'lucide-react';
import { cn } from '@/utils';
import styles from './DragHandle.module.scss';

export interface DragHandleProps {
  className?: string;
}

export const DragHandle: React.FC<DragHandleProps> = ({ className }) => (
  <span className={cn(styles.dragHandle, className)} title="Drag to reorder">
    <GripVertical style={{ width: '1em', height: '1em' }} />
  </span>
);

export default DragHandle;
